<template>
  <div v-r-loading="loading" class="current-address__content">
    <div v-if="!inputVal" class="current-address__common current-address__show">
      <template v-if="fillterAddressList && fillterAddressList.length">
        <div
          v-for="(item, index) in fillterAddressList"
          :key="index"
          class="delivery-address__content_line"
          @click.stop="selectFoodAddress(item)"
        >
          <SwiperCell
            :show-del="verifyCurrentAidVal !== (item.aid ? item.aid : '')"
            :h5-visible="h5Visible"
            @editOperation="editAddressAction('listPage', item, index)"
            @delOperation="delOperation(item.aid, index, item)"
          >
            <div slot="content" class="delivery-address__content finger-style">
              <div class="delivery-address">
                <div class="address-info">
                  <div class="info-name">
                    <div
                      class="info-dispalyname ellipsis"
                      :class="{
                        'info-dispalyname__flex': item.type,
                        'info-dispalyname__select':
                          verifyCurrentAidVal == (item.aid ? item.aid : ''),
                      }"
                    >
                      {{ $useOptionChain(item, 'poi.displayName') }}
                    </div>
                    <div v-if="item.type" class="set-position">
                      {{ item.type === 1 ? $t('家') : $t('公司') }}
                    </div>
                  </div>
                  <div class="info-desc ellipsis info-desc_bottom">
                    {{ $useOptionChain(item, 'poi.addressAll') }}
                  </div>
                  <div
                    v-if="
                      $useOptionChain(item, 'buildingName') || $useOptionChain(item, 'houseNumber')
                    "
                    class="info-desc ellipsis"
                  >
                    {{ $useOptionChain(item, 'houseNumber') }}
                    {{ $useOptionChain(item, 'buildingName') }}
                  </div>
                </div>
                <div
                  v-if="verifyCurrentAidVal == (item.aid ? item.aid : '')"
                  class="address-select"
                  :class="{
                    'address-select_right': !isLogin || typeName == 'billLading',
                  }"
                >
                  <i class="el-icon-check"></i>
                </div>
                <div
                  v-if="!isH5 && isLogin && !isBillLading"
                  class="address-edit"
                  @click.stop="editAddressAction('listPage', item, index)"
                >
                  {{ $t('编辑') }}
                </div>
              </div>
            </div>
          </SwiperCell>
        </div>
      </template>
      <div v-else-if="loading" class="no-loading-height"></div>
      <NoList
        v-else-if="isH5 && !fillterAddressList.length"
        :no-img="NODATAADDRESS"
        :no-text="getNoText"
      ></NoList>
      <NoList
        v-else-if="!isH5 && !fillterAddressList.length"
        :no-img="NODATAADDRESS"
        img-top="120px"
        :no-text="getNoText"
      ></NoList>
    </div>
    <div v-else class="current-address__common current-address_select">
      <div
        v-for="(item, index) in poiList"
        :key="index"
        class="delivery-address__content"
        @click="editAddressAction('textSearch', item, index)"
      >
        <div class="delivery-address finger-style">
          <div class="address-info">
            <div class="info-name ellipsis">
              {{ item.displayName }}
            </div>
          </div>
          <div class="info-desc ellipsis">
            {{ item.address }}
          </div>
        </div>
      </div>
      <div v-if="loading"></div>
      <NoList
        v-else-if="isH5 && !poiList.length"
        :no-img="NODATAADDRESS"
        :no-text="getNoText"
      ></NoList>
      <NoList
        v-else-if="!isH5 && !poiList.length"
        :no-img="NODATAADDRESS"
        img-top="120px"
        :no-text="getNoText"
      ></NoList>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { getLocalStorage } from '@/utils/localStorage'

import NODATAADDRESS from '@/assets/images/didi/no-data_address.png'
import NoList from '../NoList'
import SwiperCell from '../SwiperCell'
import { getAddressLogInfo } from '@/const/logs'
Object.freeze(NODATAADDRESS)
export default {
  components: {
    NoList,
    SwiperCell,
  },
  props: {
    loading: Boolean,
    typeName: {
      type: String,
      default: '', // billLading 代表提单页面的地址
      required: false,
    },
    inputVal: {
      type: String,
      default: '',
      required: true,
    },
    poiList: {
      type: Array,
      default: () => [],
      required: true,
    },
    fillterAddressList: {
      type: Array,
      default: () => [],
      required: true,
    },
    // eslint-disable-next-line vue/require-default-prop
    currentAid: {
      required: '',
      type: String,
    },
    h5Visible: {
      type: Boolean,
    },
    // eslint-disable-next-line vue/prop-name-casing
    SFNoAddress: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return { NODATAADDRESS }
  },
  computed: {
    ...mapState({
      // loading: ({ address }) => address.loading,
      isH5: ({ common }) => common.isH5,
    }),
    isLogin() {
      return getLocalStorage('isLogin')
    },
    isBillLading() {
      return this.typeName === 'billLading'
    },
    verifyCurrentAidVal() {
      const isIncludeAddressList = this.fillterAddressList?.filter(
        // eslint-disable-next-line eqeqeq
        item => item.aid == this.currentAid,
      )
      // 校验aid是否存在地址列表内
      return isIncludeAddressList?.[0]?.aid ? isIncludeAddressList?.[0]?.aid : ''
    },
    getNoText() {
      if (this.SFNoAddress) {
        return this.$t('FoodC_optimization_rmLx_bSmk')
      }
      return this.$t('抱歉，未找到任何结果')
    },
  },
  created() {
    if (this.SFNoAddress) {
      this.$trackEvent({
        eventId: 'sailing_c_x_address_list_sw',
        eventLabel: '地址列表页展现',
      })
    }
  },
  methods: {
    editAddressAction(type, addressInfos, index) {
      const { current_page, current_path } = getAddressLogInfo()

      // eslint-disable-next-line eqeqeq
      if (type == 'listPage') {
        this.$trackEvent({
          eventId: 'sailing_c_x_address_edit_confirm_ck',
          eventLabel: '地址列表页地址编辑确认按钮点击',
          attrs: {
            selected_result_poiid: addressInfos?.poi?.poiId,
            selected_result_aid: addressInfos?.aid,
            index,
            current_page,
            current_path,
          },
        })
        // eslint-disable-next-line eqeqeq
      } else if (type == 'textSearch') {
        this.$trackEvent({
          eventId: 'sailing_c_x_deliverydetail_choose_ck',
          eventLabel: '用户操作地址',
          attrs: {
            aid_latitude: addressInfos?.lat || '',
            aid_longitude: addressInfos?.lng || '',
            city_id: addressInfos?.cityId || '',
            country_code: addressInfos?.countryCode || '',
          },
        })
        this.$trackEvent({
          eventId: 'sailing_c_x_deliverydetail_search_ck',
          eventLabel: '地址列表搜索结果点击',
          attrs: {
            search_term: this.inputVal,
            associative_words_num: this.poiList?.length || 0,
            index,
            current_page,
            current_path,
          },
        })
      }
      this.$emit('editAddressAction', type, addressInfos, index)
    },
    selectFoodAddress(val) {
      this.$trackEvent({
        eventId: 'sailing_c_x_deliverydetail_choose_ck',
        eventLabel: '用户操作地址',
        attrs: {
          aid_latitude: val?.poi?.lat,
          aid_longitude: val?.poi?.lng,
          city_id: val?.poi?.cityId,
          country_code: val?.poi?.countryCode,
        },
      })
      this.$emit('selectFoodAddress', val)
    },
    delOperation(aid, index, item) {
      this.$emit('delAddress', aid, index, item)
    },
  },
}
</script>
<style lang="scss" scoped>
.current-address__content {
  flex: 1;
  overflow-y: auto;
  height: 100%;
}
.current-address__common {
  .delivery-address {
    padding: 17px 0;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #e5e5e5;
    .address-info {
      width: 308px;
      .info-name {
        width: 308px;
        font-size: 14px;
        color: #000000;
        font-family: 'Aspira Medium';
        font-weight: 500;
        display: flex;
        align-items: center;
        line-height: 15px;
        .info-dispalyname__flex {
          max-width: 230px;
        }
        .info-dispalyname__select {
          @include font-color();
        }
        .set-position {
          height: 16px;
          line-height: 16px;
          font-family: 'Aspira Light';
          @include font-color();
          padding: 0 4px;
          font-weight: 200;
          font-size: 12px;
          border-radius: 2px;
          @include act-tag-bg-color();
          margin: 0 4.5px;
        }
      }
      .info-desc {
        margin-top: 6px;
        font-size: 12px;
        line-height: 14px;
        color: #999999;
        font-weight: 200;
        font-family: 'Aspira Light';
      }
    }
    .address-edit {
      width: 43px;
      font-size: 14px;
      color: #ff7a45;
      letter-spacing: 0;
      text-align: right;
      font-weight: 400;
    }
    .address-select {
      flex: 1;
      text-align: end;
      padding-right: 27.5px;
      i {
        font-weight: bold;
      }
      @include font-color();
    }
    .address-select_right {
      flex: none;
      padding-right: 0;
    }
  }
  .delivery-address__content {
    padding: 0 24px;
  }
  .delivery-address__content:hover {
    background: #f5f5f7;
  }
}
.current-address_select {
  .delivery-address {
    display: block;
    .address-info {
      width: 100%;
      .info-name {
        font-family: 'Aspira Medium';
        display: block;
        font-size: 14px;
        color: #000000;
        font-weight: 500;
        margin-bottom: 4px;
        width: 100%;
      }
    }
    .info-desc {
      line-height: 14px;
      font-size: 12px;
      color: #999999;
      font-weight: 400;
    }
  }
}
.delivery-address__content_line:last-child {
  .delivery-address {
    border-bottom: none;
  }
}
@media screen and (max-width: 768px) {
  .current-address__content {
    margin: 0 rem(24);
    border-radius: rem(12);
    transform: rotate(0);
    &::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }
  }
  .current-address__common {
    overflow: hidden;
    .delivery-address {
      .address-info {
        width: 100%;
      }
    }
    .delivery-address__content:hover {
      background: #fff;
    }
  }
  .current-address__common:first-child {
    border-radius: rem(12) rem(12) 0 0;
  }
  .current-address__common:last-child {
    border-radius: 0 0 rem(12) rem(12);
  }
  .d-cur_address {
    .h5-address-content {
      .delivery-address__content {
        padding: 0 rem(18);
        .delivery-address {
          padding: rem(40) 0;
          .info-desc {
            font-family: 'Aspira Light';
            font-weight: 200;
            margin-top: rem(12);
            width: rem(610);
            font-size: rem(24);
            line-height: rem(28);
          }
          .address-select {
            padding-right: 0;
            i {
              font-weight: bold;
              font-size: rem(30);
            }
          }
          .address-info {
            .info-name {
              line-height: rem(32);
              font-size: rem(28);
              font-family: 'Aspira Medium';
              font-weight: 500;
            }
            .info-desc {
              font-family: 'Aspira Light';
              font-weight: 200;
              margin-top: rem(12);
              width: rem(610);
              font-size: rem(24);
              line-height: rem(28);
            }
          }
        }
      }
      .delivery-address__content:last-child {
        .delivery-address {
          border-bottom: 0;
        }
      }
    }
  }
  .current-address__show {
    // border-radius: rem(12);
    .no-list {
      margin-top: rem(100) !important;
    }
  }
  .current-address_select {
    .no-list {
      margin-top: rem(100) !important;
    }
  }
}
</style>
